import { z } from 'zod';
import { userIdList } from '../common.js';
/** Freigabe des eigenen Kalenders für ausgewählte Kollegen (KON-072). Die Liste ersetzt die bisherige, eine leere Liste nimmt alles zurück. */
export const updateCalendarSharesInput = z.object({ userIds: userIdList }).strict();
//# sourceMappingURL=calendar-shares.js.map